var map = {
	"./PluginEventMessageTypeExample/plugin.ts": 80492,
	"./PluginEventTypeExample/plugin.ts": 30235,
	"./PluginMenuExample/plugin.ts": 71068,
	"./PluginRoomExample/plugin.ts": 37104,
	"./PluginRoomTypeExample/plugin.ts": 71576,
	"./PluginToolExample/plugin.ts": 29325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93777;